<p-toast position="top-right"></p-toast>

<div class="training-attendance-report-responsive p-g">
    <div class="p-g-12">
        <div class="card card-w-title" [ngClass]="{ 'loading': loading }">

            <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
                    styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
                    animationDuration=".5s"></p-progressSpinner>
            </div>

            <h1 class="title">{{setLabel("trainersAttendenceLabel")}}</h1>

            <p-table [value]="attendecereports" [paginator]="true" [rows]="100" [responsive]="true" [loading]="loading"
                class="reportTrainerResopnsive p-table-tecfolk-fix">

                <ng-template pTemplate="caption">
                    <div class="reportMainFilter">
                        <div class="reportMainFields">
                            <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("searchByMembershipIDLabel")}}</span>
                                <input pinputtext="" [(ngModel)]="tagNumber" autocomplete="off"
                                [placeholder]='setLabel("searchHerePlaceholderLabel")' type="number" name="tagNumber"
                                    class="p-inputtext p-corner-all p-state-default p-widget">
                            </div>
                            <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("fromLabel")}}</span>
                                <p-calendar class="p-calendar-from" [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="from" [placeholder]='setLabel("fromDatePlaceholderLabel")'
                                    [inputStyle]="{'color':'#ffffff'}" name="joinDate" [inline]="false"
                                    dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="calenderDateChange()">
                                </p-calendar>
                            </div>
                            <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("toLabel")}}</span>
                                <p-calendar class="p-calendar-to" [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="to" [placeholder]='setLabel("toDatePlaceholderLabel")'
                                    [inputStyle]="{'color':'#ffffff'}" name="joinDate" [inline]="false"
                                    dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="calenderDateChange()">
                                </p-calendar>
                            </div>


                            <div class="reportMainBtn">
                                <span [pTooltip]='setLabel("searchTooltipLabel")' tooltipPosition="top" [disabled]="loading" (click)="search()"><i
                                        class="fa fa-search"></i></span>

                                <span [pTooltip]='setLabel("clearTooltipLabel")' tooltipPosition="top" class="iconClear" [disabled]="loading" (click)="resetFilter()">
                                    <i class="pi pi-times"></i></span>
                            </div>
                        </div>

                        <div class="reportMainBtn">
                            <span [pTooltip]='setLabel("searchTooltipLabel")' tooltipPosition="top" class="hideOnLaptop" [disabled]="loading" (click)="search()"><i
                                    class="fa fa-search"></i></span>
                            <span [pTooltip]='setLabel("clearTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop" [disabled]="loading"
                                (click)="resetFilter()"> <i class="pi pi-times"></i></span>
                            <!-- <button [disabled]="loading" (click)="search()"
                                style="background: #4CAF50; color: white;margin-top: 10px;"
                                class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                                    class="fa fa-search"></i>&nbsp;Search</button>
                            <button [disabled]="loading" style="background: #555555; color: white;margin-top: 10px;"
                                (click)="resetFilter()"
                                class="p-button p-widget p-state-default p-corner-all p-button-text-only">Clear</button> -->

                            <span [pTooltip]='setLabel("printTooltipLabel")' tooltipPosition="top" [disabled]="loading" [disabled]="!isData"
                                (click)="printAllInvoice()"><i class="fa fa-print"></i></span>

                            <!-- <button [disabled]="loading" style="background: #008CBA; color: white;margin-top: 10px;"
                                (click)="printAllInvoice()" [disabled]="!isData"
                                class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                                    class="fa fa-print" aria-hidden="true"></i> Print</button> -->


                            <!-- <span [pTooltip]='setLabel("sendToOwnerTooltipLabel")' tooltipPosition="top" [disabled]="loading" [disabled]="!isData"
                                (click)="showEmailConfirmationModal()"><i class="fa fa-envelope"></i></span> -->

                            <!-- <button [disabled]="loading" style="background: #4d4bdf; color:white;margin-top: 10px;"
                                (click)="showEmailConfirmationModal()" [disabled]="!isData"
                                class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                                    class="fa fa-at" aria-hidden="true"></i> Send To Owner</button> -->
                            <span *ngIf='this.role.name === "Admin" || this.role.name === "Super Admin"'
                                [pTooltip]='setLabel("exportTooltipLabel")' tooltipPosition="top" [disabled]="loading" [disabled]="!isData"
                                (click)="ExportData(attendecereports , 'Trainer_Attendance_Report')"><i
                                    class="fa fa-download"></i></span>

                            <!-- <button (click)="ExportData(attendecereports , 'Trainer_Attendance_Report')"
                                style="margin-right: 8px; background-color: #1ab352;margin-top: 10px;"
                                class="p-button p-widget p-state-default p-corner-all p-button-text-only"
                                *ngIf='this.role.name === "Admin" || this.role.name === "Super Admin"'><i
                                    class="fa fa-file-excel-o"></i>&nbsp;Export
                            </button> -->

                        </div>
                    </div>

                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{setLabel("membershipNoLabel")}}</th>
                        <!-- <th>Name</th> -->
                        <th>{{setLabel("photoLabel")}}</th>
                        <!-- <th> Date</th> -->
                        <th>{{setLabel("attendanceDateLabel")}}</th>
                        <th>{{setLabel("attendanceTimeLabel")}}</th>
                        <!-- <th>End Time</th> -->
                        <!-- <th>Marked By</th> -->
                        <th>{{setLabel("trainerNameLabel")}}</th>
                        <th>{{setLabel("mobileLabel")}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>

                    <tr>

                        <td><span class="td-title ">{{setLabel("membershipNo:Label")}}</span><span>{{rowData.membershipNo}}</span></td>
                        <!-- <td ><span
                                class="">Name:</span>{{rowData.name}}</td> -->
                        <td>
                            <span class="td-photo-title ">{{setLabel("photo:Label")}}</span>
                            <a (click)="openPhoto(rowData.profile,rowData.gender)">
                                <img [alt]="" [src]="rowData.profile
                                ?  config.Server + 'assets/layout/images/company_' + user.company + '/branch_' + user.branch + '/trainers/' + rowData.profile
                                :  rowData.gender && rowData.gender == 'F'
                                ? 'assets/layout/images/avatarGirlImage.png'
                                : 'assets/layout/images/avatarBoyImage.png'"
                                    onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" width="60"
                                    style="vertical-align: middle; border-radius: 50%; " />
                            </a>
                        </td>
                        <!-- <td ><span
                                class="">Date:</span>{{rowData.end | date: 'fullDate'}}</td> -->
                        <td><span class="td-title ">{{setLabel("startDate:Label")}}</span>{{rowData.start | date: 'fullDate'}}</td>
                        <td><span class="td-title ">{{setLabel("startTime:Label")}}</span>{{rowData.start | date: 'shortTime'}}</td>
                        <!-- <td ><span class="">End
                                Time:</span>{{rowData.end | date: 'shortTime'}}</td> -->
                        <!-- <td ><span class="">Marked
                                By:</span>{{rowData.markedBy}}</td> -->
                        <td><span class="td-title ">{{setLabel("trainerName:Label")}}</span>{{rowData.trainerName}}</td>
                        <td><span class="td-title ">{{setLabel("contact:Label")}}
                                :</span>{{rowData.contact}}</td>
                    </tr>

                </ng-template>
                <ng-template pTemplate="footer">
                    <tr *ngIf="attendenceCount != 0">

                        <td class="salesEmptyDiv"></td>
                        <td class="salesEmptyDiv"></td>
                        <td class="salesEmptyDiv"></td>
                        <td class="salesEmptyDiv"></td>
                        <td
                            style="font-size: 16px; font-weight: bold; text-align: center; position: relative; left: 70px;">
                            {{setLabel("summaryLabel")}}
                        </td>
                        <td class="" style="border: 1px solid #ababab;"></td>
                    </tr>
                    <tr *ngIf="attendenceCount != 0">

                        <td class="salesEmptyDiv"></td>
                        <td class="salesEmptyDiv"></td>
                        <td class="salesEmptyDiv"></td>
                        <td class="salesEmptyDiv"></td>
                        <td
                            style="font-size: 16px; font-weight: 500; text-align: right;border: 1px solid #ababab; text-align: start;">
                            {{setLabel("totalCountLabel")}}</td>
                        <td style="font-size: 16px; font-weight: 500;border: 1px solid #ababab;text-align: end;">
                            {{attendenceCount}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <span>{{setLabel("thereareLabel")}} {{attendenceCount}} {{setLabel("recordsLabel")}}</span>
                </ng-template>
            </p-table>
        </div>
        <div *ngIf="imgPreview" (click)="closePhotoPreview()"
            style="position: fixed; top: 0; left: 0; height: 100vh; width: 100vw; z-index: 999999; display: flex; align-items: center; justify-content: center; background: #000000cf;">
            <svg (click)="closePhotoPreview()"
                style="width: 20px; position: absolute; top: 30px; right: 40px; color: #fff; cursor: pointer;"
                aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
                class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 352 512">
                <path fill="currentColor"
                    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                </path>
            </svg>
            <img [src]="imgPreviewImg
            ? config.Server + 'assets/layout/images/company_' + user.company + '/branch_' + user.branch + '/trainers/' +imgPreviewImg
            : 'assets/layout/images/avatarBoyImage.png'" onerror="this.src = 'assets/layout/images/avatarBoyImage.png'"
                style="width: 25vw; height: auto;background: #fff;" />
        </div>
    </div>
</div>

<div id="allInvoice" style="display: none;">
    <div class="invoice-box">
        <table>
            <tbody>
                <td style="vertical-align: middle;padding: 0px;"><img
                        [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        onerror="this.src=(company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        alt="Company Logo" style="width: 80%;"> </td>

                <td style="text-align: right;">
                    <div style="width: 438px;">{{branch.name}}</div>
                    <div style="width: 438px;">{{branch.address}}</div>
                    <div>
                        {{setLabel("phoneNo:Label")}} {{branch.phone}}
                    </div>
                    <div>
                        {{setLabel("created:Label")}} {{date | date: 'dd/MM/yyyy'}}
                    </div>
                </td>
            </tbody>
        </table>
        <!-- <div style="display: flex;justify-content: space-between;">
            <div style=" width:40%">
              <img [src]="company.bannerImage == null ? config.Server + 'assets/layout/images/logoCompany.png' : config.Server + company.bannerImage"
                  onerror="this.src='../../../assets/layout/images/aboutlogo.png'"
                  alt="Company Logo" style="width: 70%;">
            </div>
            <div style="text-align: center; width: 36%;">
              <span>{{company.address}}</span> <br/>
                  <div>
                   Phone No: 0{{company.phone}}
                  </div>
                  <div>
                    Created: {{date | date: 'dd/MM/yyyy'}}
                  </div>
            </div>
          </div> -->
        <table cellpadding="0" cellspacing="0">

            <tr class="information">
                <td colspan="4">
                    <table>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <table style="border-spacing: inherit;" class="tablerpt">
                    <tbody>
                        <tr style="background-color: black;color: white;text-align: center;">

                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("m#Label")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("nameLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("photoLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("dateLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("startTimeLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("endTimeLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("markedByLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("trainerNameLabel")}}
                            </td>
                        </tr>
                        <tr class="item" *ngFor="let item of attendecereports">

                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;border-left: 1px solid gray;">
                                {{item.membershipNo}}</td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                {{item.name}}</td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                <img width="60" style="vertical-align: middle;"
                                    src="{{config.Server + 'assets/layout/images/company_' + user.company + '/branch_' + user.branch + '/trainers/' + item.profile}}"
                                    onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" alt="">
                            </td>

                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                <div *ngFor="let items of item.attendence">
                                    {{items.end | date: 'fullDate'}}
                                </div>
                            </td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                <div *ngFor="let items of item.attendence">
                                    {{items.start | date: 'shortTime'}}
                                </div>
                            </td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                <div *ngFor="let items of item.attendence">
                                    {{items.end | date: 'shortTime'}}
                                </div>
                            </td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                <div *ngFor="let items of item.attendence">
                                    {{items.markedBy}}
                                </div>
                            </td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;border-right: 1px solid gray;vertical-align: middle;font-size: 11px;">
                                {{item.trainerName}}</td>
                        </tr>
                    </tbody>
                </table>
            </tr>
        </table>
        <div style="width: 110px;float: right;">
            <!-- <p>Fee Total: {{totalSales}}</p> -->
        </div>
        <div class="logoDiv">
            {{setLabel("poweredByLabel")}} &nbsp;
            <a href="http://tecfolk.com/" target="_blank"><img style="width:66px;"
                    src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt=""></a>
        </div>
    </div>
</div>

<app-email-confirmation-modal [email]="email" [getHtml]="htmlToPdf" [company]="company.name"
    (sendingBackBranchOwnerMail)="sendingBackBranchOwnerMail($event)" [emailConfirmationModal]="emailConfirmationModal"
    (closeEmailComfirmationModal)="closeEmailComfirmationModal()">
</app-email-confirmation-modal>